/* (c) Dalineage, s.r.o. 2020-2025, all rights reserved */
package com.dalineage.client.diagram

import scala.collection.immutable._

import com.dalineage.client
import client.adt.PropertyPanelADT
import client.PropertyPanel

import com.dalineage.common
import org.scalablytyped.runtime.StringDictionary

import scala.util.chaining._

object DiagramContextMenu {

  import client.adt.PropertyPanelADT.{Button, KeyValue, Property, HelpText}
  import common.adt.PropertyPanelADT.{PropertyName }

  def menu(node: StringDictionary[?]): List[Property] = {

    val key = node("key").toString
    val typ = node("type").toString
    val caption = node("caption").toString

    node.get("isGroup").map(_.toString) match {
      case Some("true") =>
        node("expanded").toString match
          case "true" =>
            val bspace = Button("Collapse group", 32, "diagramWindow")
            val benter = Button("Enter into group", 13, "diagramWindow")
            HelpText( s"Press <b>[ Space ]</b> to ${PropertyPanel.button(bspace)}." ) ::
            HelpText( s"Press <b>[ Enter ]</b> to ${PropertyPanel.button(benter)}." ) ::
            Nil
          case _ =>
            val bspace = Button("Expand group", 32, "diagramWindow")
            KeyValue( PropertyName.GroupKey.toString, node("key").toString, None ) ::
            HelpText(
              s"Press <b>[ Space ]</b> or <b>[ Enter ]</b> to ${PropertyPanel.button(bspace)}."
            ) :: Nil
      case _ =>
        //table
        val bspace = Button("Expand columns", 32, "diagramWindow")
        HelpText( s"Press <b>[ Space ]</b> to ${PropertyPanel.button(bspace)}." ) ::
        Nil
    } pipe { groupMenu =>
      node.get("group").map(_.toString) match
        case Some(group) =>
          val besc = Button("Exit group", 27, "diagramWindow")
          groupMenu :+ HelpText( s"Press <b>[ Esc ]</b> to ${PropertyPanel.button(besc)}." )
        case _ => groupMenu
    } pipe { groupMenu =>
      HelpText( "Object selected on <i>Lineage Diagram</i>." ) ::
      KeyValue( PropertyName.ObjectType.toString, typ, None ) ::
      KeyValue( PropertyName.ObjectKey.toString, key, None ) ::
      KeyValue( PropertyName.ObjectName.toString, caption, None ) ::
      groupMenu
    }
  }
}
